import { Row } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import "./NotFoundTable.css";
import { FormattedMessage } from "react-intl";

const NotFoundTable = (props: any) => {
  const [selection, setSelection] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  // const [filters, setFilters] = useState({
  //     'global': { value: null, matchMode: 'contains'}
  // });
  const [filters, setFilters] = useState(Object);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    initGlobalFilters();
  }, []);

  const initGlobalFilters = () => {
    setFilters({
      global: { value: null, matchMode: "contains" },
    });

    // {value: null, matchMode: 'contains'}
  };

  const onSelectionChange = (row: any) => {
    setSelection(row.value);

    if (props.handlerSelectionRow) props.handlerSelectionRow(row.value);
  };

  const onSearch = (value: any) => {
    let _filters = { ...filters };
    _filters["global"].value = value;

    console.log("_Filters", _filters);
    console.log("Valor", value);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    var colsSearch: number = 2;

    if (!props.handlerDelete) colsSearch++;
    if (!props.handlerEdit) colsSearch++;
    if (!props.handlerAddSizeGuide) colsSearch += 2;
    if (!props.handlerDownload) colsSearch++;

    return (
      <>
        <Row className="justify-content-center">
          {/* <Col xs={1}>
                    <PushButtonFilter title={'Masculino'} quantity={'0'} />
                </Col> */}

          {/* <Col xs={colsSearch}>
                    <InputSearch onInputChange={onSearch} />
                </Col> */}
          {/* {
                    props.handlerDelete ?
                        <Col>
                            <ButtonCommon label="Borrar" eventClick={props.handlerDelete} disabled={((selection.length === 0) ? true : false)} />
                        </Col>
                    : <></>
                }
                {
                    props.handlerEdit ?
                        <Col>
                            <ButtonCommon label="Editar" eventClick={props.handlerEdit} disabled={((selection.length === 0) ? true : false)} />
                        </Col>
                    : <></>
                }
                {
                    props.handlerAddSizeGuide ?
                        <Col>
                            <ButtonCommon label="Asociar guía" eventClick={props.handlerAddSizeGuide} disabled={((selection.length === 0) ? true : false)} />
                        </Col>
                    : <></>
                }
                {
                    props.handlerDownload ?
                        <Col>
                            <ButtonCommon label="Descargar" eventClick={props.handlerDownload} isOutline={true} />
                        </Col>
                    : <></>
                }    */}
        </Row>
      </>
    );
  };

  const handleClick = (event: any) => {
    setShow(!show);
    setTarget(event.target);
  };

  return (
    <>
      <div className="table-fitprenda-content">
        <DataTable
          value={props.products}
          dataKey="Code"
          header={renderHeader()}
          responsiveLayout="scroll"
          scrollable
          scrollHeight={"430px"}
          // virtualScrollerOptions={{itemSize: (props.scrollHeight ? props.products.length : 5), lazy: true}}
          selectionMode="checkbox"
          selection={selection}
          onSelectionChange={(e: any) => onSelectionChange(e)}
          size="small"
          filters={filters}
          globalFilterFields={["Code", "Alias", "Description"]}
          loading={props.isLoading || false}
        >
          {props.handlerSelectionRow ? (
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3em" }}
              style={{ maxWidth: "54px" }}
            ></Column>
          ) : null}
          <Column
            field="Code"
            header={
              <FormattedMessage id="ready-size-model" defaultMessage="Modelo" />
            }
            sortable
            style={{ minWidth: "110px" }}
          ></Column>
          <Column
            field="Alias"
            header={
              <FormattedMessage
                id="edit-size-guide-widget-use-title"
                defaultMessage="Sugerencia"
              />
            }
            sortable
            style={{ minWidth: "200px" }}
          ></Column>
          <Column
            field="Description"
            header={
              <FormattedMessage
                id="ready-size-description"
                defaultMessage="Descripción"
              />
            }
            sortable
            style={{ minWidth: "150px" }}
          ></Column>
          <Column
            field="Position"
            header={<FormattedMessage id="header-type" defaultMessage="Tipo" />}
            sortable
            style={{ minWidth: "80px" }}
          ></Column>
          <Column
            field="Genre"
            header={
              <FormattedMessage
                id="ready-size-gender"
                defaultMessage="Género"
              />
            }
            sortable
            style={{ minWidth: "80px" }}
          ></Column>
          <Column
            field="Fit"
            header={
              <FormattedMessage id="ready-size-fit" defaultMessage="Fit" />
            }
            sortable
            style={{ minWidth: "80px" }}
          ></Column>
          <Column
            field="Sizes"
            header={
              <FormattedMessage id="ready-size-sizes" defaultMessage="Talles" />
            }
            sortable
            style={{ minWidth: "110px" }}
          ></Column>
          <Column
            field="Category"
            header={
              <FormattedMessage
                id="product-grid-category"
                defaultMessage="Categoría"
              />
            }
            sortable
            style={{ minWidth: "130px" }}
          ></Column>
          <Column
            field="SizeGuide"
            header={
              <FormattedMessage id="ready-size-guide" defaultMessage="Guía" />
            }
            sortable
            style={{ minWidth: "150px" }}
          ></Column>
        </DataTable>
      </div>
    </>
  );
};

export default NotFoundTable;
